module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcolorbond.net.au/images/our_services_1-16ec8c6bbab3c40346a8d262ffa87fec.jpg";